module.exports = __webpack_public_path__ + "static/img/icono cerrar naranja.5635211c.svg";